import React from "react";

interface SolicitacaoProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
  style?: React.CSSProperties;
}
const IconSolicitacao: React.FC<SolicitacaoProps> = ({ className, width, height, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    style={style}
  >
<mask id="mask0_658_2502" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<rect width="24" height="24" />
</mask>
<g mask="url(#mask0_658_2502)">
<path d="M15.95 22L11.7 17.75L13.1 16.35L15.95 19.2L21.6 13.55L23 14.95L15.95 22ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V10.35L15.975 16.375L13.1 13.5L8.875 17.725L11.15 20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z" />
</g>
</svg>
);
export default IconSolicitacao;
